export default __webpack_public_path__ + "static/media/1010.8e192855.png";